import * as R from 'ramda'
import { omitDeep } from '../gql-utils'
export type Maybe<T> = T | null
export type NotificationType = "Dummy" | "LegacyEmail" | "LegacyFax" | "LegacyIVR"
export type ServiceType = "DELIVERY" | "PICKUP" | "CURBSIDE" | "DINEIN"
export type OrderTime = "PLACED_TIME" | "FIRE_TIME" | "PICKUP_TIME" | "DELIVERY_TIME"
export type UUID = string
export type ID = number

export type Locale = "en" | "ie"
export type TemplateType= "ORDER_EMAIL" | "ORDER_FAX" | "USER_ORDER" | "ORDER_V4" | "OZ_PREVIEW" | "OZ_RECEIPT"

export interface ExternalLegacyTemplate {
  id: number
  title: string
  content: string
  custom: boolean
  default: boolean
  locale: Maybe<Locale>
  parameters: Maybe<string>
  scope: TemplateType
  subject: string
}

type DefinedNotifications = {
  [key in NotificationType]: string;
}

export const definedNotifications : DefinedNotifications = {
  "Dummy": "Dummy",
  "LegacyEmail": "Restaurant Order as Email",
  "LegacyFax": "Restaurant Order as Fax",
  "LegacyIVR": "IVR Call",
}

export interface StandardOutcomes {
  success: Maybe<string>
  failure: Maybe<string>
  accept: Maybe<string>
  reject: Maybe<string>
}

export interface Notification {
  id?: number
  name: string
  workflow_uuid: UUID
  restaurant_id: ID
  type: NotificationType
  workflow_nodes: string[]
  disabled: boolean
  location_id: Maybe<number>
  service_type: Maybe<ServiceType>
  outcomes: StandardOutcomes
}


export interface Overrides {
  delivery: Maybe<string>
  pickup: Maybe<string>
  curbside: Maybe<string>
  dinein: Maybe<string>
}

export interface AddressWithOverrides {
  address: string
  has_override: boolean
  overrides: Overrides
}

export interface DummyNotification extends Notification { }

interface EmailSettings extends AddressWithOverrides {
  template_id: Maybe<number>
}
export interface LEmailRestaurantOrder extends Notification { 
  settings: EmailSettings
}

interface FaxSettings extends AddressWithOverrides {
  template_id: Maybe<number>
}
export interface LFaxRestaurantOrder extends Notification {
  settings: FaxSettings
}

export interface LIVRCall extends Notification {
  settings: AddressWithOverrides
}

export type ValidNotification = DummyNotification | LEmailRestaurantOrder | LFaxRestaurantOrder | LIVRCall

export interface RestaurantLocation {
  id: number
  address: {
    id: number
    city: string
    nickname: string
    state: string
    street: string
    zip: string
    lat: number
    lng: number
  }
  configuration: any
}


export type EditorMode = "New" | "Update"

export function extractNotifications(notifications : any[]) : Notification[] {
  const fixNotifications = R.compose(
    omitDeep('__typename'), 
    R.evolve({settings: JSON.parse.bind(JSON)}
  ))
  return R.map(fixNotifications, notifications) as unknown[] as Notification[]
}
